var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.itemComponent,_vm._b({tag:"component",class:`type-${_vm.item.type}`},'component',{
    ..._vm.$props,
    next: _vm.item.type === 'conditional_section' ? _vm.next?.type : null,
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }